import { Sparkles } from "lucide-react";

// Shared "AI Summary" digest card — a 10-second clinical snapshot reused on
// both the Doctor Dashboard's "Current Patient" card and the Patient Profile's
// "AI Insights" tab, so both surfaces stay visually and structurally identical.
export default function AiSummaryDigestCard({ digest, testId = "ai-summary-card" }) {
  const hasDigest = digest && Object.keys(digest).length > 0;
  return (
    <div className="card-surface card-surface-hover rounded-xl border border-slate-200 bg-white shadow-sm p-6" data-testid={testId}>
      <h2 className="flex items-center gap-2 font-semibold text-slate-900">
        <Sparkles className="h-4 w-4 text-teal-700" /> AI Summary
      </h2>
      {hasDigest ? (
        <ul className="mt-3 space-y-1.5 text-sm text-slate-700" data-testid="ai-summary-digest">
          {digest.vitals_line && (
            <li className="flex gap-2" data-testid="ai-summary-vitals"><span className="text-teal-600">•</span> {digest.vitals_line}</li>
          )}
          {digest.allergies_line && (
            <li className="flex gap-2" data-testid="ai-summary-allergies"><span className="text-teal-600">•</span> {digest.allergies_line}</li>
          )}
          {digest.trend_line && (
            <li className="flex gap-2" data-testid="ai-summary-trend"><span className="text-teal-600">•</span> {digest.trend_line}</li>
          )}
          {digest.medicines?.length > 0 && (
            <li data-testid="ai-summary-medicines">
              <div className="flex gap-2"><span className="text-teal-600">•</span> Active Medicines:</div>
              <ul className="ml-5 mt-1 space-y-1">
                {digest.medicines.map((m, i) => (
                  <li key={`${i}-${m}`} className="text-slate-600" data-testid={`ai-summary-medicine-${i}`}>- {m}</li>
                ))}
              </ul>
            </li>
          )}
          {digest.pending_investigation_line && (
            <li className="flex gap-2" data-testid="ai-summary-pending-investigation"><span className="text-teal-600">•</span> {digest.pending_investigation_line}</li>
          )}
          {digest.followup_line && (
            <li className="flex gap-2" data-testid="ai-summary-followup"><span className="text-teal-600">•</span> {digest.followup_line}</li>
          )}
        </ul>
      ) : (
        <p className="mt-3 text-sm text-slate-400" data-testid="ai-summary-empty">
          No clinical data recorded yet for this patient.
        </p>
      )}
    </div>
  );
}
